


































































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';

export default {
    name: 'TheAddonsFields',
    components: {
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            addons: {},
            temp: {},
            price: { disabled: false, value: '' },
            priceVAT: { disabled: false, value: '' },
        };
    },
    watch: {
        'temp.price'(value) {
            if (value !== '') {
                this.priceVAT.disabled = true;
                this.priceVAT.value = String((Number(this.temp.price) * 1.20).toFixed(2));
            } else {
                this.priceVAT.disabled = false;
                this.priceVAT.value = '';
            }
        },
        'temp.priceVAT'(value) {
            if (value !== '') {
                this.price.disabled = true;
                this.price.value = String((Number(this.temp.priceVAT) / 1.20).toFixed(2));
            } else {
                this.price.disabled = false;
                this.price.value = '';
            }
        },
    },
    methods: {
        onSubmit() {
            this.$emit('addAddon', {
                name: this.addons.name,
                minimum_selected: this.addons.minimum_selected,
                maximum_selected: this.addons.maximum_selected,
                options: Object.assign(this.addons.options),
            });
            this.addons.options = [];
        },
        onOptionSubmit() {
            this.addons.options.push({
                name: this.temp.name,
                price: this.temp.price === '' ? this.price.value : this.temp.price,
                price_with_vat: this.temp.priceVAT === '' ? this.priceVAT.value : this.temp.priceVAT,
            });
        },
        deleteAddonsOption(index) {
            this.addons.options.splice(index, 1);
        },
    },
    created() {
        this.addons = {
            name: '',
            minimum_selected: '',
            maximum_selected: '',
            options: [],
        };

        this.temp = {
            name: '',
            price: '',
            priceVAT: '',
        };
    },
};
